module.exports = __webpack_public_path__ + "static/img/md-person.ca44ee97.svg";